import Vue from 'vue'
import {API3_HOST,API2_HOST, API_HOST} from './constant'
import {errorMessage} from './error.js'

function get(scope, options = {}) {
  options = Object.assign({}, options)
  let params = Object.assign({}, options.params || {})
  if (!options.secondRoot && !options.thirdRoot)
    params.api = options.api

  if (options.getLs) {
    let res = null
    let lastTime = localStorage.getItem(options.path + options.api + 'time')
    if (lastTime && options.getLsTime && options.getLsTime < (+lastTime) + 24 * 3600 * 1000)
      res = localStorage.getItem(options.path + options.api)
    if (res) {
      return new Promise(resolve => {
        resolve({
          body: {
            result: JSON.parse(res)
          }
        })
      })
    }
  }
  let obj = {}
  obj.params = params
  if (options.responseType)
    obj.responseType = options.responseType
  if (options.thirdRoot)
    Vue.http.options.root = `${API3_HOST}/api`
  else if (options.secondRoot)
    Vue.http.options.root = API2_HOST
  else
    Vue.http.options.root = `${API_HOST}/api`
  if (options.data && options.data.subdomain)
    Vue.http.options.root = `//${options.data.subdomain}.joyorders.com/api`
  let promise = scope.$http.get(options.path, obj)

  if (options.loading) {
    scope[options.loading] = true
  }

  if (options.setLs) {
    promise.then(res => {
      localStorage.setItem(options.path + options.api, JSON.stringify(res.body.result))
      if (options.getLsTime)
        localStorage.setItem(options.path + options.api + 'time', options.getLsTime)
    })
  }

  promise.finally(() => {
    if (options.loading) {
      scope[options.loading] = false
    }
  })
  promise.then(res => {
    if (res.body.hasOwnProperty('status') && res.body.status !== 'ok') {
      if(res.body.code==401){
        setTimeout(function () {
          scope.$router.push({path:'/login'})
        },2000)
      }else {
        scope.$message.error(res.body.msg || res.body.result)
      }
    }
  })
  return promise
}

function post(scope, options = {}) {
  options = Object.assign({}, options)
  let params = Object.assign({
    data: {}
  }, options.params || {})
  if (!options.secondRoot && !options.thirdRoot)
    params.api = options.api

  if (options.loading) {
    scope[options.loading] = true
  }
  if (options.thirdRoot)
    Vue.http.options.root = `${API3_HOST}/api`
  else if (options.secondRoot)
    Vue.http.options.root = API2_HOST
  else
    Vue.http.options.root = `${API_HOST}/api`
  if (options.data && options.data.subdomain)
    Vue.http.options.root = `//${options.data.subdomain}.joyorders.com/api`
  //console.log('post',options);
  let promise = scope.$http.post(options.path, options.data, {
    params: params
  })

  promise.finally(() => {
    if (options.loading) {
      scope[options.loading] = false
    }
  })
  promise.then(res => {
    //console.log('post',res);
    if (res.body.status !== 'ok') {
      //scope.$message.error(res.body.msg || res.body.result);
      if(res.body.code==401){
        setTimeout(function () {
          scope.$router.push({path:'/login'})
        },2000)
      }else{
        if(res.body.result!='no_match_found'){
          if(errorMessage[res.body.result])
            scope.$message.error(errorMessage[res.body.result])
          else
            scope.$message.error(res.body.msg || res.body.result)
        }
      }
    }
  })
  return promise
}

// 一键查询
function getSupportBusinessList(scope, options = {}) {
  return get(scope, Object.assign({
    path: 'onekey.php',
    api: 'get_support_business_list'
  }, options))
}
function getGroupBussinessList(scope, options = {}) {
  return get(scope, Object.assign({
    path: 'business.php',
    api: 'get_list_order_by_alphabet'
  }, options))
}

function getLatestAddress(scope) {
  return get(scope, {
    path: 'buyer.php',
    api: 'get_latest_address',
    loading: 'loading'
  })
}

function getLatestPaymentType(scope) {
  return get(scope, {
    path: 'buyer.php',
    api: 'get_latest_payment_type',
    loading: 'loading'
  })
}

function getAddressList(scope, options = {}) {
  return get(scope, Object.assign({
    path: 'buyer.php',
    api: 'get_address_list',
    loading: 'loading'
  }, options))
}

function getPaymentTypeList(scope) {
  return get(scope, {
    path: 'buyer.php',
    api: 'get_payment_type_list',
    loading: 'loading'
  })
}

function getSingleList(scope, options = {}) {
  return get(scope, Object.assign({
    path: 'order.php',
    api: 'get_single_list',
    loading: 'loading'
  }, options))
}

function getUserInfo(scope) {
  return get(scope, {
    path: 'passport.php',
    api: 'get_info'
  })
}

//获取商品信息by货号
function getGoodsDetailBySku(scope, params) {
  return get(scope, {
    path: 'good.php',
    api: 'get_detail_by_sku',
    params: params
  })
}

function getGoodsDetailById(scope, params) {
  return get(scope, {
    path: 'good.php',
    api: 'get_detail',
    params: params
  })
}

function getSameGoods(scope,params){
  return get(scope, {
    path: 'good.php',
    api: 'get_same_spu_good_list_for_wechat',
    params: params
  })
}

/**
 * 状态，0未生成，11待接单，12待支付，13待下单，14下单中，15待发货，16待收货，20已完成，30已取消
 * @param {*} scope
 * @param {*} params
 */
function getOrders(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_my_list_for_buyer',
    params: params
  })
}

function getOrderById(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_by_id',
    params: params
  })
}

function getDetailById(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_detail',
    params: params
  })
}
/**
 * 状态，0未生成，11待接单，12待支付，13待下单，14下单中，15待发货，16待收货，20已完成，30已取消
 * @param {*} scope
 * @param {*} params
 */
function getOrdersCount(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'count_my_list_for_buyer',
    params: params
  })
}
function getOrdersMerchants(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_merchant_list_for_single',
    params: params
  })
}
function getBuyers(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_single_info_list',
    params: params
  })
}
function generateShortUrl(scope, params) {
  return post(scope, {
    path: 'create',
    api: '',
    thirdRoot: true,
    data: params
  })
}
function getLongUrl(scope, params) {
  return post(scope, {
    path: 'get_long',
    api: '',
    thirdRoot: true,
    params: params
  })
}
function getMailList(scope, params) {
  return get(scope, {
    path: 'mail/get_mail_list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getMailContent(scope, params) {
  return get(scope, {
    path: 'mail/get_mail_content',
    api: '',
    secondRoot: true,
    params: params
  })
}

function getCardList(scope, params) {
  return get(scope, {
    path: 'gift_card/list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getCardSourceList(scope, params) {
  return get(scope, {
    path: 'gift_card/source/list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getCardCurrencyList(scope, params) {
  return get(scope, {
    path: 'config/currency/list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getCardBrandList(scope, params) {
  return get(scope, {
    path: 'gift_card/brand/list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getCardBatchList(scope, params) {
  return get(scope, {
    path: 'gift_card/batch/list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function addCardBatch(scope, params) {
  return post(scope, {
    path: 'gift_card/batch/add',
    api: '',
    secondRoot: true,
    data: params
  })
}
function addGiftCardHistory(scope, params) {
  return post(scope, {
    path: 'gift_card/add_history',
    api: '',
    secondRoot: true,
    data: params
  })
}
function getMonitorList(scope, params) {
  return get(scope, {
    path: 'express_monitor/list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getMonitorGroupList(scope) {
  return get(scope, {
    path: 'express_monitor/group_tag_list',
    api: '',
    secondRoot: true,
  })
}
function addMonitor(scope, params) {
  return post(scope, {
    path: 'express_monitor/add',
    api: '',
    secondRoot: true,
    data: params
  })
}
function updateMonitor(scope, params) {
  return post(scope, {
    path: 'express_monitor/update',
    api: '',
    secondRoot: true,
    data: params
  })
}
function getMonitorLog(scope, params) {
  return get(scope, {
    path: 'express_monitor/get_monitor_log',
    api: '',
    secondRoot: true,
    params: params
  })
}
function daigouList(scope, params) {
  return get(scope, {
    path: 'transport_company.php',
    api: 'get_fifteenhaoku_daigou_list',
    params: params
  })
}
function getMyArticleList(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'get_my_post_list',
    params: params
  })
}
function getMyArticleCount(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'count_my_post_list',
    params: params
  })
}
function getMyLikeArticleList(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'get_my_like_post_list',
    params: params
  })
}
function getMyLikeArticleCount(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'count_my_like_post_list',
    params: params
  })
}
function getMyCollArticleList(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'get_my_fav_post_list',
    params: params
  })
}
function getMyCollArticleCount(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'count_my_fav_post_list',
    params: params
  })
}
function getArticleList(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'get_post_list',
    params: params
  })
}
function getArticleCount(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'count_post_list',
    params: params
  })
}
function getProductList(scope, page,limit,params) {
  return post(scope, {
    path: 'search.php?page='+page+'&limit='+limit,
    api: 'get_good_list',
    data: params
  })
}
function getCollectionProductList(scope, params) {
  return get(scope, {
    path: 'cm.php',
    api: 'get_my_fav_good_list',
    params: params
  })
}
function addArticle(scope, params) {
  return post(scope, {
    path: 'cm.php',
    api: 'add_post',
    data: params
  })
}
function updateArticle(scope, params) {
  return post(scope, {
    path: 'cm.php',
    api: 'update_post',
    data: params
  })
}
function getTicketList(scope, params) {
  return post(scope, {
    path: 'ticket.php',
    api: 'get_list',
    data: params
  })
}
function getTicketListCount(scope, params) {
  return post(scope, {
    path: 'ticket.php',
    api: 'count_list',
    data: params
  })
}
function getTicketComments(scope, params) {
  return get(scope, {
    path: 'ticket.php',
    api: 'get_reply_list',
    params: params
  })
}
function addTicket(scope, params) {
  return post(scope, {
    path: 'ticket.php',
    api: 'add',
    data: params
  })
}
function updateTicket(scope, params) {
  return post(scope, {
    path: 'ticket.php',
    api: 'update',
    data: params
  })
}
function updateComment(scope, params) {
  return post(scope, {
    path: 'ticket.php',
    api: 'update_reply_visible_range',
    data: params
  })
}
function replyTicket(scope, params) {
  return post(scope, {
    path: 'ticket.php',
    api: 'reply',
    data: params
  })
}
function getTicketTypes(scope, params) {
  return get(scope, {
    path: 'ticket.php',
    api: 'get_type_list',
    params: params
  })
}
function getTicketStatus(scope, params) {
  return get(scope, {
    path: 'ticket.php',
    api: 'get_status_list',
    params: params
  })
}
function getReplyTemplate(scope, params) {
  return post(scope, {
    path: 'ticket.php',
    api: 'reply_sms_preview_template',
  })
}
function getTicketPriorities(scope, params) {
  return get(scope, {
    path: 'ticket.php',
    api: 'get_priority_list',
    params: params
  })
}
function getTicketAccounts(scope, params) {
  return get(scope, {
    path: 'ticket.php',
    api: 'get_assigned_to_group_list',
    params: params
  })
}
function getTicketVisible(scope, params) {
  return get(scope, {
    path: 'ticket.php',
    api: 'get_visible_range_list',
    params: params
  })
}
function getMailThemes(scope) {
  return get(scope, {
    path: 'mail/get_mail_theme_list',
    api: '',
    secondRoot: true,
  })
}
function getMailReceiver(scope) {
  return get(scope, {
    path: 'mail/get_receiver_list',
    api: '',
    secondRoot: true,
  })
}
function getMixSender(scope) {
  return get(scope, {
    path: 'mail/get_mix_sender_merchant',
    api: '',
    secondRoot: true,
  })
}
function bindingMailTask(scope, params) {
  return post(scope, {
    path: 'mail/add_mail_task_relation',
    api: '',
    secondRoot: true,
    data: params
  })
}
function updateMailInfo(scope, params) {
  return post(scope, {
    path: 'mail/update_mail_info',
    api: '',
    secondRoot: true,
    data: params
  })
}
function getPrivacy(scope){
  return get(scope, {
    path: 'homepage.php',
    api: 'privacy'
  })
}
function getNoteCustomer(scope){
  return get(scope, {
    path: 'homepage.php',
    api: 'notetocustomer'
  })
}
function getTerms(scope){
  return get(scope, {
    path: 'homepage.php',
    api: 'termsofuse'
  })
}
/**
 * 状态，0未生成，11待接单，12待支付，13待下单，14下单中，15待发货，16待收货，20已完成，30已取消
 * @param {*} scope
 * @param {*} params
 */
function getSingleOrders(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_my_list_for_single',
    params: params
  })
}

function exportSingleOrders(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_my_list_for_single',
    responseType: "blob",
    params: params
  })
}

/**
 * 状态，0未生成，11待接单，12待支付，13待下单，14下单中，15待发货，16待收货，20已完成，30已取消
 * @param {*} scope
 * @param {*} params
 */
function getSingleOrdersCount(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'count_my_list_for_single',
    params: params
  })
}

/**
 * 状态，0未生成，11待接单，12待支付，13待下单，14下单中，15待发货，16待收货，20已完成，30已取消
 * @param {*} scope
 * @param {*} params
 */
function getMerchantOrders(scope, params) {
  return get(scope, {
    path: 'merchant_order.php',
    api: 'get_list',
    params: params
  })
}

function exportMerchantOrders(scope, params) {
  return get(scope, {
    path: 'merchant_order.php',
    api: 'get_list',
    responseType: "blob",
    params: params
  })
}

function getMerchantOrderUpdateTime(scope, params) {
  return get(scope, {
    path: 'merchant_order.php',
    api: 'get_last_update_time',
    params: params
  })
}

/**
 * 状态，0未生成，11待接单，12待支付，13待下单，14下单中，15待发货，16待收货，20已完成，30已取消
 * @param {*} scope
 * @param {*} params
 */
function getMerchantOrdersCount(scope, params) {
  return get(scope, {
    path: 'merchant_order.php',
    api: 'count_list',
    params: params
  })
}
function getMerchantOrderAccount(scope) {
  return get(scope, {
    path: 'merchant_order.php',
    api: 'get_account_list',
    //params: params
  })
}
function getMerchants(scope) {
  return get(scope, {
    path: 'merchant_order.php',
    api: 'get_merchant_list',
    //params: params
  })
}
function getTransportCompanyList(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_express_company_list',
    params: params
  })
}
function getTransportAddressList(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_transport_address_list',
    params: params
  })
}

function getExpressList(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_express_list',
    params: params
  })
}
function getShipDelegateList(scope) {
  return get(scope, {
    path: 'order.php',
    api: 'get_shipping_account_list'
  })
}
function getExceptionTypeList(scope) {
  return get(scope, {
    path: 'order_exception.php',
    api: 'get_config'
  })
}
function getExceptionStatusList(scope) {
  return get(scope, {
    path: 'order_exception.php',
    api: 'get_status_list'
  })
}
function getTransportStatusArray(scope) {
  return get(scope, {
    path: 'order.php',
    api: 'get_transport_status_map'
  })
}
function getEarliestDate(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_earliest_date',
    params: params
  })
}

function getOverview(scope, params) {
  return get(scope, {
    path: 'single.php',
    api: 'get_overview',
    params: params
  })
}

function getIncome(scope, params) {
  return get(scope, {
    path: 'single.php',
    api: 'get_income_and_expense_info',
    params: params
  })
}

function getIncomeList(scope, params) {
  return get(scope, {
    path: 'single.php',
    api: 'get_income_and_expense_list',
    params: params
  })
}

function getIncomeListCount(scope, params) {
  return get(scope, {
    path: 'single.php',
    api: 'count_income_and_expense_list',
    params: params
  })
}

function getWithdrawList(scope, params) {
  return get(scope, {
    path: 'single.php',
    api: 'get_withdraw_type_list',
    params: params
  })
}

function getListByWebsite(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_by_website',
    params: params
  })
}

function getCartList(scope, params) {
  return get(scope, {
    path: 'cart.php',
    api: 'get_list',
    params: params
  })
}

function countUnreadForBuyer(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'count_unread_for_buyer',
    params: params
  })
}

function countUnreadForSingle(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'count_unread_for_single',
    params: params
  })
}

function getUnreadForBuyer(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'get_unread_for_buyer',
    params: params
  })
}

function getUnreadForSingle(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'get_unread_for_single',
    params: params
  })
}

function countMessagesForBuyer(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'count_for_buyer',
    params: params
  })
}

function countMessagesForSingle(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'count_for_single',
    params: params
  })
}

function getMessagesForBuyer(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'get_for_buyer',
    params: params
  })
}

function getMessagesForSingle(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'get_for_single',
    params: params
  })
}

function getUnread(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'get_unread',
    params: params
  })
}

function countUnread(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'count_unread',
    params: params
  })
}

function getMessages(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'get',
    params: params
  })
}

function countMessages(scope, params) {
  return get(scope, {
    path: 'notification.php',
    api: 'count',
    params: params
  })
}

function getBusinessList(scope, params) {
  return get(scope, {
    path: 'homepage.php',
    api: 'get_business_list',
    params: params
  })
}

function searchBusiness(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'search_business',
    params: params
  })
}

function checkPaidStatus(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'check_paid_status',
    params: params
  })
}

function getBuyerList(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_buyer_list',
    params: params
  })
}

function getBusinessListbyalphabet(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_list',
    params: params
  })
}

function getPoolList(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_pool_list',
    params: params
  })
}

function getPoolBusinessList(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_business_list_for_pool',
    params: params
  })
}

function getVoucherList(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_voucher_list',
    params: params
  })
}

function getGoodList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_goods_list',
    params: params
  })
}

function countGoodList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'count_goods_list',
    params: params
  })
}
function getOfferGoodsList(scope, params) {
  return get(scope, {
    path: 'good.php',
    api: 'get_tmp_good_list',
    params: params
  })
}

function getGoodDetail(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_good_detail',
    params: params
  })
}

function getSephoraGoodList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_sephora_goods_list',
    params: params
  })
}

function getSephoraGoodCount(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'count_sephora_goods_list',
    params: params
  })
}

function getSephoraTagList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_sephora_level_list',
    params: params
  })
}

function getSephoraBrandList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_sephora_brand_list',
    params: params
  })
}

function getLevelListByBusiness(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_level_list_by_business',
    params: params
  })
}

function getNormalLevelList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_normal_level_list',
    params: params
  })
}

function getBrandListByBusiness(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_brand_list_by_business',
    params: params
  })
}

function getExchangeRates(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_exchange_rates_list',
    params: params
  })
}

function getHelpCategory(scope, params) {
  return get(scope, {
    path: 'homepage.php',
    api: 'get_setting_help_category_list',
    params: params
  })
}

function getHelpList(scope, params) {
  return get(scope, {
    path: 'homepage.php',
    api: 'get_setting_help_list',
    params: params
  })
}

function searchHelpList(scope, params) {
  return get(scope, {
    path: 'homepage.php',
    api: 'search_setting_help_list',
    params: params
  })
}

function getGoodDetailAgain(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'regenerate_good_detail',
    params: params
  })
}

function serchBusinessList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_business_list',
    params: params
  })
}

function getMerchantDetail(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get',
    params: params
  })
}

function get_transport_amount_template_relationship_list_by_id_list(scope, params) {
  return post(scope, {
    path: 'good.php',
    api: 'get_transport_amount_template_relationship_list_by_id_list',
    params: params
  })
}

function get_good_weight_info_list(scope, params) {
  return post(scope, {
    path: 'good.php',
    api: 'get_good_weight_info_list',
    params: params
  })
}

function serchGoodsList(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_goods_list',
    params: params
  })
}
function serchAddressBySingle(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'search_address_by_keyword',
    params: params
  })
}

function getIDByTag(scope, params) {
  return get(scope, {
    path: 'business.php',
    api: 'get_id_by_tag',
    params: params
  })
}
function getSupportAccountList(scope) {
  return post(scope, {
    path: 'order.php',
    api: 'get_support_auto_add_address_zhuanyun_account_list',
  })
}
function getEditSupportAccountList(scope) {
  return post(scope, {
    path: 'order.php',
    api: 'get_support_edit_address_zhuanyun_account_list',
  })
}
function getAddressAccountList(scope, params) {
  return post(scope, {
    path: 'order.php',
    api: 'get_matched_zhuanyun_address_list',
    data: params
  })
}
function getUserBindedAccountList(scope) {
  return get(scope, {
    path: 'order.php',
    api: 'get_bound_zhuanyun_account_list',
  })
}

function getExpressAdminAccountList(scope,params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_express_company_administrator_list',
    params: params
  })
}

function getTransportFormData(scope, params) {
  return get(scope, {
    path: 'transport_company.php',
    api: 'get_input_info_when_declare_a_package',
    params: params
  })
}

function getTransportFormDataChuku(scope, params) {
  return get(scope, {
    path: 'transport_company.php',
    api: 'get_input_info_when_submit_shipment',
    params: params
  })
}

function getTransportFormDataChuku2(scope, params) {
  return get(scope, {
    path: 'transport_company.php',
    api: 'get_package_info_when_submit_shipment',
    params: params
  })
}

function submitTransportFormData(scope, params) {
  return post(scope, {
    path: 'transport_company.php',
    api: 'declare_a_package',
    data: params
  })
}

function submitTransportFormDataChuku(scope, params) {
  return post(scope, {
    path: 'transport_company.php',
    api: 'submit_shipment',
    data: params
  })
}

function submitTransportFormData15haoku(scope, params) {
  return post(scope, {
    path: 'transport_company.php',
    api: 'delivery',
    data: params
  })
}
function giftCardHistoryList(scope, params) {
  return get(scope, {
    path: 'gift_card/history_list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getUnderBuyList(scope, params) {
  return get(scope, {
    path: 'cart/list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getUnderBuyBusinessList(scope, params) {
  return get(scope, {
    path: 'cart/business_list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getUnderBuyBrandList(scope, params) {
  return get(scope, {
    path: 'cart/brand_list',
    api: '',
    secondRoot: true,
    params: params
  })
}
function getExpressCompanyListForOutbound(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_express_company_list_for_outbound',
    params: params
  })
}
function getZhuanyunAccountListByExpressCompany(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_zhuanyun_account_list_by_express_company',
    params: params
  })
}

/**
* @Description: 美通弹窗
* @Author: talon
* @Date: 2024/12/3
*/
function fetchMTTrace(scope, params) {
  return get(scope, {
    path: 'order.php',
    api: 'get_51daigou_order_query_track',
    params: params
  })
}
/**
 *转运账单
 * @param scope
 * @param params
 * @returns {*|*}
 */
function getOutboundDetailList(scope, params) {
  if( params.transport_store_number){
    params.transport_store_number=params.transport_store_number.split("*")[0]
  }
  return get(scope, {
    path: 'order.php',
    api: 'get_outbound_detail_list',
    params: params
  })
}
function countOutboundDetailList(scope, params) {
  if( params.transport_store_number){
    params.transport_store_number=params.transport_store_number.split("*")[0]
  }
  return get(scope, {
    path: 'order.php',
    api: 'count_outbound_detail_list',
    params: params
  })
}
function updateRecommendationIndex(scope, params) {
  return post(scope, {
    path: 'good.php',
    api: 'update_recommendation_index',
    data: params
  })
}
function packageTracking(scope,data){
  return post(scope, {
    path: 'order.php',
    api: 'package_tracking',
    data: data
  })
}
function getConfig(scope,params){
  return get(scope, {
    path: 'bill.php',
    api: 'get_config',
    params: params
  })
}

function countBillList(scope,params){
  return post(scope, {
    path: 'bill.php',
    api: 'count_bill_list',
    data: params
  })
}
function getBillList(scope,params){
  return post(scope, {
    path: 'bill.php',
    api: 'get_bill_list',
    data: params
  })
}
function countBillSettlementList(scope,params){
  return post(scope, {
    path: 'bill.php',
    api: 'count_bill_settlement_list',
    data: params
  })
}

function getBillSettlementList(scope,params){
  return post(scope, {
    path: 'bill.php',
    api: 'get_bill_settlement_list',
    data: params
  })
}


function addBill(scope,data){
  return post(scope, {
    path: 'bill.php',
    api: 'add_bill',
    data: data
  })
}
function updateBill(scope,data){
  return post(scope, {
    path: 'bill.php',
    api: 'update_bill',
    data: data
  })
}
function addBillSettlement(scope,data){
  return post(scope, {
    path: 'bill.php',
    api: 'add_bill_settlement',
    data: data
  })
}
function updateBillSettlement(scope,data){
  return post(scope, {
    path: 'bill.php',
    api: 'update_bill_settlement',
    data: data
  })
}

function get_units(scope, params) {
  return get(scope, {
    path: 'good.php',
    api: 'get_support_size_unit_list',
    params: params
  })
}
function get_category_list(scope, params) {
  return get(scope, {
    path: 'good.php',
    api: 'get_category_list',
    params: params
  })
}
export default {
  get_units,
  get_category_list,
  get,
  post,
  getConfig,
  countBillList,
  getBillList,
  countBillSettlementList,
  getBillSettlementList,
  addBill,
  updateBill,
  addBillSettlement,
  updateBillSettlement,
  packageTracking,
  updateRecommendationIndex,
  fetchMTTrace,
  getUnderBuyBrandList,
  getUnderBuyBusinessList,
  getExpressCompanyListForOutbound,
  getZhuanyunAccountListByExpressCompany,
  getOutboundDetailList,
  countOutboundDetailList,
  getCartList,
  addGiftCardHistory,
  giftCardHistoryList,
  getGroupBussinessList,
  getLatestAddress,
  getAddressList,
  getPaymentTypeList,
  getSingleList,
  getLatestPaymentType,
  getUserInfo,
  getOrders,
  getOrdersCount,
  getOrdersMerchants,
  getBuyers,
  getMailList,
  generateShortUrl,
  getLongUrl,
  getCardList,
  getCardSourceList,
  getCardBrandList,
  getCardCurrencyList,
  getCardBatchList,
  addCardBatch,
  getMonitorList,
  getMonitorGroupList,
  addMonitor,
  updateMonitor,
  daigouList,
  getTicketList,
  getMyArticleList,
  getMyArticleCount,
  getMyLikeArticleList,
  getMyLikeArticleCount,
  getMyCollArticleList,
  getMyCollArticleCount,
  getArticleList,
  getArticleCount,
  getProductList,
  getCollectionProductList,
  addArticle,
  updateArticle,
  getTicketListCount,
  getTicketComments,
  addTicket,
  updateTicket,
  updateComment,
  replyTicket,
  getTicketTypes,
  getTicketStatus,
  getReplyTemplate,
  getTicketPriorities,
  getTicketAccounts,
  getTicketVisible,
  getMailThemes,
  getMailReceiver,
  getMixSender,
  bindingMailTask,
  updateMailInfo,
  getPrivacy,
  getNoteCustomer,
  getTerms,
  getSingleOrders,
  exportSingleOrders,
  getSingleOrdersCount,
  getMerchantOrders,
  exportMerchantOrders,
  getMerchantOrderUpdateTime,
  getMerchantOrdersCount,
  getMerchantOrderAccount,
  getMerchants,
  getTransportCompanyList,
  getTransportAddressList,
  getExpressList,
  getShipDelegateList,
  getTransportStatusArray,
  getExceptionTypeList,
  getExceptionStatusList,
  getEarliestDate,
  getOrderById,
  getOverview,
  getListByWebsite,
  getUnderBuyList,
  getIncome,
  getIncomeList,
  getIncomeListCount,
  getWithdrawList,
  countUnreadForBuyer,
  countUnreadForSingle,
  countMessagesForBuyer,
  countMessagesForSingle,
  getMessagesForBuyer,
  getMessagesForSingle,
  getUnreadForBuyer,
  getUnreadForSingle,
  getBusinessList,
  checkPaidStatus,
  searchBusiness,
  getBuyerList,
  getDetailById,
  getBusinessListbyalphabet,
  getPoolList,
  getPoolBusinessList,
  getVoucherList,
  getGoodList,
  countGoodList,
  getExchangeRates,
  getHelpCategory,
  getHelpList,
  searchHelpList,
  getUnread,
  countUnread,
  getMessages,
  countMessages,
  getSephoraGoodList,
  getSephoraGoodCount,
  getSephoraTagList,
  getSephoraBrandList,
  getGoodDetail,
  getOfferGoodsList,
  getGoodDetailAgain,
  getLevelListByBusiness,
  getBrandListByBusiness,
  serchBusinessList,
  getMerchantDetail,
  get_transport_amount_template_relationship_list_by_id_list,
  get_good_weight_info_list,
  serchGoodsList,
  getNormalLevelList,
  serchAddressBySingle,
  getIDByTag,
  getSupportBusinessList,
  getGoodsDetailBySku,
  getGoodsDetailById,
  getSameGoods,
  getAddressAccountList,
  getSupportAccountList,
  getEditSupportAccountList,
  getUserBindedAccountList,
  getExpressAdminAccountList,
  getTransportFormData,
  submitTransportFormData,
  submitTransportFormData15haoku,
  submitTransportFormDataChuku,
  getTransportFormDataChuku,
  getTransportFormDataChuku2,
  getMonitorLog,
  getMailContent
}



// WEBPACK FOOTER //
// ./src/services/api.js